import styled, { css } from 'styled-components';

export const DescriptionWrapper = styled.div`
  ${({ theme }) => css`
    span {
      color: ${theme.v2.colors.neutral.lowDark};
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v2.font.sizes.xs}
      font-weight: ${theme.v2.font.weights.regular};
      line-height: ${theme.v2.font.lineHeight.text};
    }
  `}
`;

export const Doubt = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs}
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 24px 0px 0px 0px
  `}
`;

export const ProgressBarLine = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: no-wrap;
    gap: 16px;
    justify-content: center;
    margin: 32px 0px 0px 0px;
    width: 100%;

    @media(max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
    }
  `}
`;

export const ProgressBarWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  max-width: 100%;
  width: 100%;
  > div {
    max-width: 100%;
    width: 100%;
    > div {
      &:before {
        left: 0;
      }
    }
  }
`;

export const ProgressBarLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    min-width: fit-content;
  `}
`;

export const DragAndDropArea = styled.label`
  ${({ theme, $disabled }) => css`
    align-items: center;
    border-radius: 8px;
    border: 1px dashed ${theme.v2.colors.neutral.highMedium};
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    flex-direction: column;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    gap: 24px;
    justify-content: center;
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 32px 0;
    max-width: calc(100% - 48px);
    padding: 24px;
    text-align: center;
    width: 100%;

    &:hover {
      cursor: pointer;
    
      ${$disabled && css`
        cursor: not-allowed;
      `}
    }
    
    ${$disabled && css`
      background-color: ${theme.v2.colors.neutral.highLight};
      cursor: not-allowed;
    `}
  `}
`;

export const InvisibleInput = styled.input`
  display: none;
  visibility: hidden;
`;


export const AttachedFiles = styled.ul`
  list-style: none;
  margin: 0px;
  padding: 0px;
  min-width: 100%;
`;

export const AttachedFile = styled.li`
  ${({ theme }) => css`
    align-items: center;
    border-top: 1px solid ${theme.v2.colors.neutral.highMedium};
    color: ${theme.v2.colors.neutral.lowMedium};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    gap: 12px;
    justify-content: flex-start;
    line-height: ${theme.v2.font.lineHeight.text};
    max-width: 100%;
    padding: 24px 0px;
    width: 100%;
  `}
`;

export const FileName = styled.span`
  display: block;
  max-width: 289px;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;

export const ActionWrapper = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
  margin-left: auto;
`;
